import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

const documentExposureReducer = (state = initialState.document.exposure, action) => {
  switch (action.type) {
    case actionTypes.LOAD_EXPOSURE_STARTED: {
      return {
        ...state,
        [action.id]: {
          loading: true
        }
      };
    }
    case actionTypes.LOAD_EXPOSURE_SUCCESS: {
      const exposure = action.payload;
      return {
        ...state,
        [action.id]: {
          loading: false,
          loaded: true,
          exposure
        }
      };
    }
    case eventTypes.EXPOSURE_COMPUTED: {
      const { documentId, siteId } = action.event.eventBody;
      const key = `${documentId}-${siteId}`;

      return {
        ...state,
        [key]: {
          loaded: false,
          loading: false
        }
      };
    }

    case eventTypes.EXPOSURE_CURRENCIES_RETRIEVED: {
      const { documentId, siteId, exposureCurrencies } = action.event.eventBody;
      const key = `${documentId}-${siteId}`;

      return {
        ...state,
        [key]: {
          exposureCurrencies: exposureCurrencies
        }
      };
    }

    default:
      return state;
  }
};

export default documentExposureReducer;
